import { $, $$, body } from "@utils/dom";
import { on, off } from "@utils/listener";
import { mobile } from "@utils/mobile";
import Throttle from "@utils/throttle";
import anime from "animejs";

export const SELECTOR = "[data-site-super-menu]";
export const NAV_SELECTOR = ".site-super-menu__nav";
export const PANEL_SELECTOR = ".site-panel";
export const MENU_DELAY = 250;

class SiteSuperMenu {
  constructor(init = false) {
    this.initialized = false;
    this.opened = false;
    this.el = null;

    this.currentId = null;
    this.currentDelay = MENU_DELAY;

    this.currentHeight = 0;

    init ? this.init() : null;

    this._onEnter = this._onEnter.bind(this);
    this._onMobileClick = this._onMobileClick.bind(this);
    this._onBackdropClick = this._onBackdropClick.bind(this);
    this._open = this._open.bind(this);
    this._selectCurrentNav = this._selectCurrentNav.bind(this);
    this._onLeave = this._onLeave.bind(this);
    this._onLeaveUnlessOpened = this._onLeaveUnlessOpened.bind(this);
    this._close = this._close.bind(this);
    this._toggle = this._toggle.bind(this);
    this._animatePanel = this._animatePanel.bind(this);
  }

  get name() {
    return `SiteSuperMenu`;
  }

  init() {
    this.initialized = true;
    this.el = $(SELECTOR);

    this.backdrop = $('.site-super-menu__backdrop', this.el);
    this.container = $('.site-super-menu__container', this.el);
    this.triggers = [...$$(`[aria-controls="${this.el.id}"]`)];

    this.navs = [...$$(NAV_SELECTOR)].map(el => new SiteSuperMenuNav(el));

    this.navThrottler = Throttle({cb: this._toggle, delay: 250, onlyAtEnd: false});

    this.panel = $(PANEL_SELECTOR);
    this.panelAnimation = null;

    this.currentHeight = getComputedStyle(this.panel).getPropertyValue('--defaultHeight');

    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    this.el = null;
    this.initialized = false;
    this.opened = false;

    if( this.navs ) this.navs.forEach(nav => nav.destroy());

    this.backdrop = null;
    this.container = null;
    this.triggers = null;
    this.navs = null;
    this.promoCircles = null;

    if(this.navThrottler) this.navThrottler.dispose();
    this.navThrottler = null;

    this.currentId = null;
    this.currentDelay = null;

    this.currentHeight = null;

    this.panel = null;
    this.panelAnimation = null;
  }

  _bindEvents() {
    if( mobile ) {
      if( this.triggers ) on(this.triggers, 'click', this._onMobileClick);
      if( this.backdrop ) on(this.backdrop, 'click', this._onBackdropClick);
    } else {
      if( this.triggers ) on(this.triggers, 'mouseenter', this._onEnter);
      if( this.triggers ) on(this.triggers, 'mouseleave', this._onLeaveUnlessOpened);
      if( this.container ) on(this.container, 'mouseleave', this._onLeave);
    }

    if( this.emitter ) {
      this.emitter.on(`SiteScroll.direction`, this._onLeave);
      this.emitter.on(`SiteHeader.mobileClick`, this._onBackdropClick);
    }

  }
  _unbindEvents() {
    if( mobile ) {
      if( this.triggers ) off(this.triggers, 'click', this._onMobileClick);
      if( this.backdrop ) off(this.backdrop, 'click', this._onBackdropClick);
    } else {
      if( this.triggers ) off(this.triggers, 'mouseenter', this._onEnter);
      if( this.triggers ) off(this.triggers, 'mouseleave', this._onLeaveUnlessOpened);
      if( this.container ) off(this.container, 'mouseleave', this._onLeave);
    }

    if( this.emitter ) {
      this.emitter.off(`SiteScroll.direction`, this._onLeave);
      this.emitter.off(`SiteHeader.mobileClick`, this._onBackdropClick);
    }
  }

  _onEnter(e){
    this.currentId = e.currentTarget.getAttribute('data-nav-id');
    this.navThrottler.init();
  }
  _onMobileClick(e) {
    if( e ) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }

    const navID = e.currentTarget.getAttribute('data-nav-id');

    this.currentId = this.currentId !== navID ? navID : null;
    this._toggle();

    return false;
  }
  _onBackdropClick(e) {
    if( e ) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }

    this.currentId = null;
    this._toggle();

    return false;
  }

  _selectCurrentNav(){
    this.navs.forEach((nav) => {
      if (nav.id == this.currentId) {

        nav._open();
        this.currentHeight = nav.el.clientHeight;
      } else {
        nav._close();
      }
    });
  }

  _onLeave(){
    this.currentId = null;
    this.navThrottler.init();
  }
  _onLeaveUnlessOpened(){
    if(!this.opened){
      this._onLeave();
    }
  }

  _open(){
    this.opened = true;

    body.classList.add('--js-site-super-menu-opened');
    this.el.setAttribute('aria-hidden', false);

    // remove delay after element open
    setTimeout(()=> {
      this.currentDelay = 0;
      this.el.style.setProperty('--menuDelay',`${this.currentDelay}ms`);
    }, 50);
  }
  _close(){
    this.opened = false;

    body.classList.remove('--js-site-super-menu-opened');
    this.el.setAttribute('aria-hidden', true);

    // add delay after element open
    this.currentDelay = MENU_DELAY;
    this.el.style.setProperty('--menuDelay',`${this.currentDelay}ms`);
  }
  _toggle(){
    this._selectCurrentNav();
    if(this.currentId){
      this._open();
    } else {
      this._close();
      this.currentHeight = getComputedStyle(this.panel).getPropertyValue('--defaultHeight');
    }

    this._animatePanel();
  }


  _animatePanel(){
    this.el.style.setProperty('--currentHeight',this.currentHeight+'px');

    var duration = 400;
    if(this.opened){
      var duration = 650;
    }

    this.panelAnimation = anime({
      targets: this.panel,
      height: this.currentHeight,
      easing: 'easeInOutCirc',
      duration: duration,
      autoplay: false
    });

    this.panelAnimation.play();
  }
}

class SiteSuperMenuNav {
  constructor(el) {
    this.el = el;
    this.video = $('.site-super-menu__promo__video', this.el);

    this.id = this.el.getAttribute('data-id');
    this.trigger = $(`[data-nav-id="${this.id}"]`);

    this._open = this._open.bind(this);
    this._close = this._close.bind(this);
  }

  destroy(){
    this.el = null;
    this.video = null;

    this.id = null;
    this.trigger = null;

    this._open = null;
    this._close = null;
  }

  _open(){
    this.el.setAttribute('aria-hidden', false);
    this.trigger.setAttribute('aria-expanded', true);
    if( this.video && !mobile ) this.video.play();
  }

   _close(){
    this.el.setAttribute('aria-hidden', true);
    this.trigger.setAttribute('aria-expanded', false);
    if( this.video && !mobile ) this.video.pause();
  }
}

export default SiteSuperMenu;
